var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerts_list_01-copy-2",
    transform: "translate(-452.000000, -27.000000)",
    fill: "#241F21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(472.000000, 47.000000) scale(-1, 1) translate(-472.000000, -47.000000) translate(452.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1461799,13.1873313 C28.0064049,11.2551111 31.1195116,24.8622028 22.012296,26.8102637 C12.9425934,28.7502282 9.81676795,15.2217537 19.1461799,13.1873313 Z M26.9327377,11.6536334 C28.6464607,10.8370847 29.8781619,13.5021195 28.2062864,14.3254549 C26.4424894,15.193916 24.9734135,12.5872231 26.9327377,11.6536334 Z M30.8101794,26.9306706 C31.1869737,24.8951627 30.8862685,18.9061675 30.8874464,16.4283939 C30.8890954,12.8103818 30.3263185,10.3409981 27.0437677,9.71671664 C24.8658049,9.30257043 19.038862,9.60976102 16.4848115,9.60746001 C7.83735315,9.59940058 9.66418708,14.3104036 9.65550633,24.0059112 C9.64779141,32.6886209 14.2816427,30.8288157 24.1812383,30.8401437 C27.7760372,30.8442737 30.2022909,30.2139153 30.8101794,26.9306706 L30.8101794,26.9306706 Z",
    id: "Fill-4",
    transform: "translate(20.250000, 20.250000) scale(-1, 1) translate(-20.250000, -20.250000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3035472,15.5472324 C13.2232295,16.6156494 14.9581047,25.6042863 20.8634947,24.5705269 C26.6975789,23.5494129 25.2439462,14.5032864 19.3035472,15.5472324",
    id: "Fill-5",
    transform: "translate(20.037830, 20.058335) scale(-1, 1) translate(-20.037830, -20.058335) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3537955,7.68809862 C16.2693128,7.35777583 22.9867513,7.53894449 26.1492644,7.65712615 C29.6440906,7.78756944 32.4178445,10.4164775 32.7923449,13.6531869 C33.12018,16.4876017 33.0010422,23.3135856 32.8353571,26.3073203 C32.6439824,29.7665105 30.0158806,32.4354686 26.6444345,32.7972964 C23.7117124,33.1121156 16.8740755,33.0086039 13.8050108,32.8337687 C10.3278608,32.6356607 7.54956997,30.077393 7.19613966,26.8021851 C6.87406697,23.8187552 7.01223617,17.3038853 7.16143532,14.1602091 C7.32494045,10.7127595 9.99183565,8.06915835 13.3537955,7.68809862 Z M18.1120207,0.110378447 C7.66139812,1.20543278 -1.00951397,10.2084479 0.0951105038,21.9182054 C1.08099001,32.3707786 10.3705377,41.0184586 21.9257028,39.9028555 C32.3028578,38.9009438 41.057005,29.7233288 39.8963752,17.9927532 C38.8898713,7.82132895 29.6603461,-1.09974879 18.1120207,0.110378447 L18.1120207,0.110378447 Z",
    id: "Fill-3",
    transform: "translate(20.000000, 20.000000) scale(-1, 1) translate(-20.000000, -20.000000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagramIcon.13eff2e47e76f31940ae8ca6b9e62a20.svg";
export { ForwardRef as ReactComponent };